import { getCoreDataSecurityUptimeMonitorsDashboardSlice } from './get';

export const { requestGetCoreDataSecurityUptimeMonitorsDashboard, resetGetCoreDataSecurityUptimeMonitorsDashboard } =
	getCoreDataSecurityUptimeMonitorsDashboardSlice.asyncActionCreators;
